export class ListWithLinkModel {
    name: string;
    link: string;
}
